
import { showVuePopup } from '../../utils/showVuePopup';
import PromotionList from '../../popup/PromotionList.vue';
import PromotionBonus from '../../popup/PromotionBonus.vue';
import PromotionCoupon from '../../popup/PromotionCoupon.vue';
import PromotionSetting from '../../popup/PromotionSetting.vue';
import { useSession } from '../../stores/session';

export default {
	name: 'PopupPromotionNavbar',
	setup() {

		const session = useSession();

		const btnClickPromotionList = async () => {
			session.set('navbar_sub', 'promotion:list');
			await showVuePopup(PromotionList, {}, {});
		}

		const btnClickPromotionBonus = async () => {
			session.set('navbar_sub', 'promotion:bonus');
			await showVuePopup(PromotionBonus, {}, {});
		}

		const btnClickPromotionCoupon = async () => {
			session.set('navbar_sub', 'promotion:coupon');
			await showVuePopup(PromotionCoupon, {}, {});
		}

		const btnClickPromotionSetting = async () => {
			session.set('navbar_sub', 'promotion:setting');
			await showVuePopup(PromotionSetting, {}, {});
		}

		return {
			session,
			btnClickPromotionList,
			btnClickPromotionBonus,
			btnClickPromotionCoupon,
			btnClickPromotionSetting,
		}
	}
}
